// extracted by mini-css-extract-plugin
export default {"p_content":"_5da4426875"};